import store from "../store";

export default class Redirect {
   constructor(route) {
      this.route = route;
      this.commit = action => store.commit(action);
      this.getters = getter => store.getters[getter];
   }

   isRegisterPage() {
      return this.route.matched.some(record => record.meta.isRegisterPage);
   }

   async signOut() {
      await localStorage.removeItem("token");
      await localStorage.removeItem("timestamp");
      await localStorage.removeItem("tokenConfig");

      this.commit("resetTokenConfig");
      this.commit("resetFilterMiscConfig");

      this.commit("organizationDone", false);
      this.commit("tokenDone", false);
   }
}
